import { render, staticRenderFns } from "./FeedbackPage2.vue?vue&type=template&id=9940ffe0&scoped=true&"
import script from "./FeedbackPage2.vue?vue&type=script&lang=js&"
export * from "./FeedbackPage2.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPage2.vue?vue&type=style&index=0&id=9940ffe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9940ffe0",
  null
  
)

export default component.exports